import React, { useEffect, useState, useLayoutEffect } from "react";
import axios from "axios";
import "./ApiDoc.css";
import logo from "../../Assets/iPurvery Logo PNG.svg";
import searchIcon from "../../Assets/Icon feather-search.png";
import copyIcon from "../../Assets/Icon material-content-copy.svg";
import Footer from "../../Layout/Footer";
import Loader from "../../Components/Loader";
import ReactMarkdown from "react-markdown";

const ApiDoc = () => {
  const [data, setData] = useState();
  const [active, setActive] = useState();
  useEffect(async () => {
    const doc = await axios.get("https://staging-cms-main.ipurvey.com/api-doc");
    const layout = await axios.get(
      "https://staging-cms-main.ipurvey.com/layout"
    );
    setData([doc.data, layout.data]);
    setActive(doc.data?.document[0].title);
  }, []);

  if (data) {
    return (
      <>
        <div className="api_doc_section">
          <div className="phead_top">
            <div></div>
            <div className="api_doc_header">
              <h2>Api Documentation</h2>
              <span>Help?</span>
            </div>
          </div>
          <div className="api_doc_hero">
            <div className="api_container">
              <div className="row gy-3">
                <div className="col-12 col-sm-12 col-md-12 col-lg-3">
                  <div className="api_list_box">
                    <div className="row">
                      <div className="col-lg-12">
                        <img src={logo} alt="..." />
                      </div>
                    </div>
                    <div className="row mt-3 w-100">
                      <div className="col-12 col-sm-12 col-md-12 col-lg-12">
                        <div className="ps_input1">
                          <input type="text" placeholder="Search" />
                          <img
                            style={{ width: "20px" }}
                            src={searchIcon}
                            alt="..."
                          />
                        </div>
                      </div>
                    </div>
                    <div className="row w-100 mt-3 ad_left_list">
                      {data[0]?.document.map((el, i) => (
                        <div
                          key={i}
                          className="col-lg-12 p-0"
                          onClick={() => setActive(el?.title)}
                        >
                          <div
                            className={
                              el?.title === active
                                ? "api_list active_list"
                                : "api_list"
                            }
                          >
                            <span>{el?.title}</span>
                          </div>
                        </div>
                      ))}
                    </div>
                  </div>
                </div>
                <div className="col-12 col-sm-12 col-md-12 col-lg-5">
                  <div className="api_content">
                    <p>
                      {data[0]?.document.map((doc) => {
                        if (doc.title == active)
                          return <ReactMarkdown>{doc.document}</ReactMarkdown>;
                      })}
                    </p>
                  </div>
                </div>
                <div className="col-12 col-sm-12 col-md-12 col-lg-3">
                  <div className="api_editor">
                    <div className="row">
                      <div className="ae_head">
                        <h2>Lorem Ipsum</h2>
                        <img src={copyIcon} alt="..." />
                      </div>
                    </div>
                    <div className="row">
                      <div className="ae_body">
                        <h6>{"<!DOCTYPE html>"}</h6>
                        <h6>{"<html>"}</h6>
                        <h6>{"<body>"}</h6>
                        <h5 className="mt-4 mb-4">
                          {"<h2>An Unordered HTML List</h2>"}
                        </h5>
                        <h6>{"<ul>"}</h6>
                        <h6>{"<li>Coffee</li>"}</h6>
                        <h6>{"<li>Tea</li>"}</h6>
                        <h6>{"<li>Milk</li>"}</h6>
                        <h6>{"</ul>"}</h6>
                        <h4>{"<h2>An Ordered HTML List</h2>"}</h4>
                        <h6>{"<ol>"}</h6>
                        <h6 style={{ color: "#FE2B2B" }}>
                          {"<li>Coffee</li>"}
                        </h6>
                        <h6>{"<li>Tea</li>"}</h6>
                        <h6>{"<li>Milk</li>"}</h6>
                        <h6>{"</ol>"}</h6>
                        <h6>{"<!DOCTYPE html>"}</h6>
                        <h6>{"<html>"}</h6>
                        <h6>{"<body>"}</h6>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
        <Footer />
      </>
    );
  } else return <Loader />;
};

export default ApiDoc;
